import React from 'react';
import ChartCompo from '../ChartCompo';
import BiddingHistory from './BiddingHistory/BiddingHistory';
import SuperstarCard from './SuperstarCard/SuperstarCard';

const RightSideAuctionWithoutTime = ({data}) => {

    return (
        <div className=" mt-4">
            <ChartCompo AuctionData={data} />
            <SuperstarCard AuctionData={data} />
        </div>
    );
};

export default RightSideAuctionWithoutTime;